import { ArrowUpRight, ShieldAlert } from "lucide-react";
import { motion } from "framer-motion";
import { SERVICES, DISCLAIMER } from "@/data/services";
import { Reveal, MaskLines, EASE } from "@/components/ui/motion";
import { waLink } from "@/lib/config";

const PHASES = [
  { no: "01", title: "Ceritakan Kondisi Anda.", text: "Sampaikan gambaran kewajiban dan kemampuan bayar Anda." },
  { no: "02", title: "Evaluasi Opsi dan Ketentuan.", text: "Kami menjelaskan opsi, biaya, dan persyaratan secara terbuka." },
  { no: "03", title: "Tentukan Langkah Berikutnya.", text: "Anda memutuskan, tanpa tekanan, setelah memahami semuanya." },
];

export const PinjolSection = () => (
  <section className="py-20 sm:py-28 lg:py-36" data-testid="pinjol-section">
    <div className="wrap grid grid-cols-1 gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <span className="eyebrow">Fokus Pinjol</span>
          <MaskLines
            as="h2"
            inView
            className="mt-5 font-display text-3xl font-bold leading-[1.06] sm:text-4xl lg:text-[50px]"
            lines={["Utang Pinjol Terasa", "Sulit Dikendalikan?", <span className="serif-it font-normal text-accentb">Mulai dari langkah yang tepat.</span>]}
          />
          <Reveal delay={0.1}>
            <p className="mt-6 text-base leading-relaxed text-ink md:text-lg">
              Ketika tagihan pinjaman online mulai membebani keuangan, memahami kondisi kewajiban dan pilihan penyelesaian merupakan langkah awal yang penting. Mika Solution menyediakan konsultasi dan pendampingan untuk membantu Anda mengevaluasi situasi serta memahami proses yang mungkin tersedia.
            </p>
            <a href={waLink("pinjol")} target="_blank" rel="noopener noreferrer" className="btn btn-sky mt-8" data-testid="pinjol-section-cta">
              Konsultasikan Kondisi Pinjol Anda <ArrowUpRight size={16} />
            </a>
          </Reveal>
        </div>
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        <Reveal><p className="text-[12px] font-bold uppercase tracking-[0.2em] text-ink-soft">Apakah ini kondisi Anda?</p></Reveal>
        <ul className="mt-5 border-t border-line">
          {SERVICES[0].situations.map((s, i) => (
            <Reveal key={s} delay={i * 0.05}>
              <li className="group flex items-baseline gap-6 border-b border-line py-6" data-testid={`pinjol-situation-${i}`}>
                <span className="font-display text-sm font-bold text-accentb">0{i + 1}</span>
                <span className="font-display text-lg font-semibold leading-snug text-slateb transition-transform duration-500 group-hover:translate-x-2 sm:text-2xl">{s}</span>
              </li>
            </Reveal>
          ))}
        </ul>
        <div className="mt-14 grid gap-4 sm:grid-cols-3">
          {PHASES.map((p, i) => (
            <motion.div
              key={p.no}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.9, ease: EASE, delay: i * 0.12 }}
              className={`rounded-3xl p-6 ${i === 1 ? "bg-slateb text-white" : "bg-ice"}`}
              data-testid={`pinjol-phase-${i}`}
            >
              <span className={`serif-it text-5xl ${i === 1 ? "text-sky-brand" : "text-accentb"}`}>{p.no}</span>
              <h3 className={`mt-6 font-display text-lg font-bold leading-tight ${i === 1 ? "!text-white" : ""}`}>{p.title}</h3>
              <p className={`mt-3 text-[14px] leading-relaxed ${i === 1 ? "text-ice" : "text-ink"}`}>{p.text}</p>
            </motion.div>
          ))}
        </div>
        <Reveal>
          <p className="mt-8 flex gap-3 rounded-2xl border border-line p-5 text-[13.5px] leading-relaxed text-ink" data-testid="pinjol-disclaimer">
            <ShieldAlert size={18} className="mt-0.5 shrink-0 text-accentb" />{DISCLAIMER}
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
